<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 212 176"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >

    <g :fill="fill"
      stroke="none" transform="translate(0,176) scale(0.100000,-0.100000)"
    >
      <path d="M337 1740 c-19 -15 -40 -20 -85 -20 -46 0 -61 -4 -66 -16 -5 -14 -4
-15 9 -4 24 20 121 -5 155 -39 l27 -26 24 26 c25 28 125 56 155 45 9 -3 12 -1
9 4 -3 6 -31 10 -62 10 -40 0 -62 5 -80 20 -14 11 -33 20 -43 20 -10 0 -29 -9
-43 -20z m61 -28 c3 -16 -2 -22 -17 -22 -26 0 -36 17 -20 36 16 19 33 13 37
-14z"
      />
      <path d="M817 1692 l-27 -28 0 -235 0 -235 28 -27 c27 -26 32 -27 147 -27 115
0 120 1 147 27 26 25 28 33 28 100 l0 73 -50 0 -50 0 0 -50 0 -50 -75 0 -75 0
0 195 0 195 75 0 75 0 0 -50 0 -50 50 0 50 0 0 67 c0 59 -3 70 -27 95 -26 28
-28 28 -148 28 -120 0 -122 0 -148 -28z"
      />
      <path d="M1237 1692 c-26 -27 -27 -32 -27 -138 0 -108 1 -111 28 -137 27 -26
33 -27 125 -27 l97 0 0 -75 0 -75 -75 0 -75 0 0 40 0 40 -50 0 -50 0 0 -64 c0
-59 2 -66 31 -90 29 -25 36 -26 147 -26 112 0 117 1 144 27 28 26 28 29 28
142 0 107 -2 118 -23 143 -22 26 -29 27 -123 30 l-99 3 -3 73 -3 72 76 0 75 0
0 -40 0 -40 50 0 50 0 0 57 c0 48 -4 61 -27 85 -26 28 -28 28 -148 28 -120 0
-122 0 -148 -28z"
      />
      <path d="M1657 1692 l-27 -28 0 -232 0 -231 30 -31 29 -30 118 0 c113 0 118 1
145 27 l28 27 0 138 0 138 -96 0 -95 0 3 -42 c3 -43 3 -43 46 -46 l42 -3 0
-70 0 -69 -75 0 -75 0 0 195 0 195 75 0 75 0 0 -40 0 -40 50 0 50 0 0 57 c0
48 -4 61 -27 85 -26 28 -28 28 -148 28 -120 0 -122 0 -148 -28z"
      />
      <path d="M2019 1703 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"
      />
      <path d="M2078 1702 c9 -10 19 -17 21 -16 6 5 -20 34 -30 34 -5 0 -1 -8 9 -18z"/>
      <path d="M2062 1674 c-1 -13 0 -24 2 -24 7 0 14 40 7 44 -4 3 -8 -6 -9 -20z"/>
      <path d="M211 1655 c0 -5 24 -86 54 -180 30 -93 55 -171 55 -172 0 -2 -58 -3
-129 -3 l-129 0 55 171 c30 94 53 172 51 174 -2 2 -33 -78 -69 -176 l-66 -180
21 -31 c11 -17 33 -40 47 -50 65 -48 180 -27 225 42 l25 37 -62 169 c-74 204
-78 212 -78 199z"
      />
      <path d="M2010 1651 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
      <path d="M2086 1643 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
      <path d="M471 1469 c-40 -109 -61 -179 -57 -194 8 -33 70 -83 111 -91 71 -13
151 20 180 76 15 30 14 35 -46 200 -34 94 -64 168 -66 166 -2 -2 19 -73 47
-158 27 -86 50 -158 50 -162 0 -3 -58 -6 -129 -6 l-129 0 54 167 c29 92 52
168 50 170 -2 2 -31 -74 -65 -168z"
      />
      <path d="M2048 1623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
      <path d="M367 1387 c-4 -93 -11 -176 -17 -186 -5 -10 -29 -28 -52 -39 l-43
-21 125 0 125 -1 -40 19 c-22 10 -46 25 -53 33 -8 10 -16 72 -23 170 -5 84
-11 162 -12 173 -1 11 -6 -56 -10 -148z"
      />
      <path d="M1157 1068 c-23 -12 -21 -35 3 -50 27 -17 25 -36 -2 -41 -17 -3 -14
-5 10 -6 27 -1 32 2 32 23 0 13 -10 30 -22 39 l-23 15 24 9 c18 7 20 11 10 15
-9 3 -23 2 -32 -4z"
      />
      <path d="M39 1043 c-16 -43 2 -73 43 -72 30 1 31 2 8 8 -20 6 -25 13 -25 41 0
28 5 35 25 41 23 6 22 7 -8 8 -27 1 -34 -4 -43 -26z"
      />
      <path d="M130 1020 c0 -48 1 -50 28 -49 16 1 20 3 10 6 -22 5 -24 33 -3 33 8
0 15 5 15 10 0 6 -7 10 -15 10 -21 0 -19 28 3 33 10 3 6 5 -10 6 -27 1 -28 -1
-28 -49z"
      />
      <path d="M200 1021 c0 -28 5 -51 10 -51 6 0 10 9 10 20 0 11 4 20 9 20 5 0 13
-9 16 -20 11 -35 21 -22 20 28 0 46 -1 47 -32 50 l-33 3 0 -50z m50 18 c0 -5
-7 -9 -15 -9 -15 0 -20 12 -9 23 8 8 24 -1 24 -14z"
      />
      <path d="M293 1059 c11 -7 17 -22 17 -49 0 -22 5 -40 10 -40 6 0 10 20 10 44
0 26 5 46 13 49 6 3 -6 6 -28 6 -32 0 -36 -2 -22 -10z"
      />
      <path d="M370 1020 c0 -27 5 -50 10 -50 6 0 10 23 10 50 0 28 -4 50 -10 50 -5
0 -10 -22 -10 -50z"
      />
      <path d="M410 1020 c0 -27 5 -50 10 -50 6 0 10 9 10 20 0 11 7 20 15 20 8 0
15 5 15 10 0 6 -7 10 -15 10 -21 0 -19 28 3 33 10 3 6 5 -10 6 -27 1 -28 -1
-28 -49z"
      />
      <path d="M480 1020 c0 -27 5 -50 10 -50 6 0 10 23 10 50 0 28 -4 50 -10 50 -5
0 -10 -22 -10 -50z"
      />
      <path d="M520 1020 l0 -50 33 1 c23 1 26 3 10 6 -25 5 -32 33 -8 33 8 0 15 5
15 10 0 6 -7 10 -15 10 -21 0 -19 28 3 33 10 3 6 5 -10 6 -27 1 -28 -1 -28
-49z"
      />
      <path d="M600 1020 l0 -51 33 3 c31 3 32 5 32 48 0 43 -1 45 -32 48 l-33 3 0
-51z m45 0 c0 -18 -6 -35 -12 -37 -9 -3 -13 8 -13 37 0 29 4 40 13 38 6 -3 12
-20 12 -38z"
      />
      <path d="M737 1063 c-13 -13 -7 -35 16 -53 l22 -19 -25 -10 -25 -10 28 0 c37
-1 47 26 19 50 -27 21 -28 36 -4 42 14 4 13 5 -4 6 -11 0 -24 -2 -27 -6z"
      />
      <path d="M800 1021 c0 -39 4 -51 15 -51 8 0 15 8 15 19 0 10 9 21 21 24 15 4
20 12 17 29 -2 18 -10 24 -35 26 l-33 3 0 -50z m42 7 c-9 -9 -12 -7 -12 12 0
19 3 21 12 12 9 -9 9 -15 0 -24z"
      />
      <path d="M888 1046 c-17 -39 3 -78 39 -74 35 4 50 29 37 65 -13 39 -59 45 -76
9z m57 -6 c8 -26 -3 -60 -20 -60 -17 0 -28 34 -20 60 3 11 12 20 20 20 8 0 17
-9 20 -20z"
      />
      <path d="M980 1020 c0 -27 5 -50 10 -50 6 0 10 9 10 20 0 11 4 20 9 20 5 0 13
-9 16 -20 3 -11 11 -20 16 -20 11 0 11 11 -1 30 -5 9 -5 19 2 27 17 21 1 43
-32 43 -29 0 -30 -1 -30 -50z m48 22 c2 -7 -3 -12 -12 -12 -9 0 -16 7 -16 16
0 17 22 14 28 -4z"
      />
      <path d="M1068 1063 c7 -3 12 -23 12 -49 0 -32 4 -44 15 -44 11 0 15 12 15 44
0 26 5 46 13 49 6 3 -6 5 -28 5 -22 0 -34 -2 -27 -5z"
      />
      <path d="M1260 1045 c-6 -16 -6 -34 0 -50 8 -20 16 -25 45 -25 30 0 35 3 35
24 0 29 -17 43 -33 27 -8 -8 -8 -11 1 -11 7 0 12 -7 12 -16 0 -9 -7 -14 -17
-12 -13 2 -18 13 -18 38 0 28 5 35 25 41 23 6 22 7 -8 8 -26 1 -34 -4 -42 -24z"
      />
      <path d="M1362 1023 c3 -46 4 -48 33 -48 29 0 30 2 33 48 2 26 -1 47 -7 47 -5
0 -11 -19 -13 -42 -4 -59 -28 -63 -28 -4 0 26 -5 46 -11 46 -6 0 -9 -19 -7
-47z"
      />
      <path d="M1456 1023 c-9 -25 -13 -49 -10 -52 4 -3 9 0 11 7 6 14 39 16 48 2
17 -28 21 -4 7 40 -9 28 -21 50 -28 50 -7 0 -19 -21 -28 -47z m30 -10 c-11
-11 -17 4 -9 23 7 18 8 18 11 1 2 -10 1 -21 -2 -24z"
      />
      <path d="M1540 1021 c0 -28 5 -51 10 -51 6 0 10 9 10 20 0 11 4 20 9 20 5 0
13 -9 16 -20 11 -35 21 -22 20 28 0 46 -1 47 -32 50 l-33 3 0 -50z m48 21 c2
-7 -3 -12 -12 -12 -9 0 -16 7 -16 16 0 17 22 14 28 -4z"
      />
      <path d="M1650 1045 c-19 -49 -22 -75 -11 -75 6 0 11 5 11 10 0 14 38 12 43
-2 2 -7 8 -10 12 -6 10 9 -18 91 -33 96 -7 2 -16 -8 -22 -23z m30 -20 c0 -8
-4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z"
      />
      <path d="M1730 1020 c0 -27 5 -50 10 -50 6 0 10 15 10 33 l1 32 14 -32 c21
-49 35 -41 34 20 -2 50 -2 51 -8 13 l-6 -39 -17 36 c-24 51 -38 46 -38 -13z"
      />
      <path d="M1828 1063 c7 -3 12 -23 12 -49 0 -24 5 -44 10 -44 6 0 10 18 10 40
0 27 6 42 18 49 13 8 9 10 -23 10 -22 0 -34 -3 -27 -6z"
      />
      <path d="M1915 1040 c8 -16 15 -38 15 -50 0 -11 5 -20 10 -20 6 0 10 9 10 20
0 12 7 34 15 50 16 32 3 43 -14 13 -9 -17 -10 -17 -16 0 -4 9 -14 17 -21 17
-12 0 -12 -5 1 -30z"
      />
      <path d="M327 760 c-18 -14 -42 -20 -84 -21 l-58 -1 50 -13 c58 -14 111 -39
119 -57 5 -11 7 -11 12 0 14 31 164 79 164 53 0 -6 5 -11 11 -11 8 0 8 5 -1
15 -8 10 -31 15 -67 15 -40 0 -62 6 -80 20 -14 11 -29 20 -33 20 -4 0 -19 -9
-33 -20z m51 -32 c-2 -13 -10 -23 -18 -23 -8 0 -16 10 -18 23 -3 17 2 22 18
22 16 0 21 -5 18 -22z"
      />
      <path d="M920 714 c-109 -30 -178 -102 -200 -211 -41 -194 112 -360 310 -340
82 9 90 14 90 54 0 33 -2 35 -25 29 -184 -46 -304 43 -293 217 9 141 129 224
263 182 28 -8 51 -15 53 -15 1 0 2 16 2 35 0 22 -6 37 -17 44 -35 18 -127 21
-183 5z"
      />
      <path d="M1333 720 c-143 -30 -231 -149 -221 -300 14 -187 162 -286 376 -250
l72 12 0 144 0 144 -95 0 -95 0 0 -30 c0 -30 1 -30 55 -30 l55 0 0 -84 c0 -78
-1 -84 -22 -90 -111 -29 -232 42 -258 153 -38 158 84 289 247 265 26 -3 60
-13 76 -21 l27 -14 0 40 c0 36 -3 40 -32 50 -50 15 -138 21 -185 11z"
      />
      <path d="M1813 720 c-85 -18 -151 -67 -191 -144 -22 -43 -26 -64 -26 -131 0
-174 101 -277 274 -279 110 -1 130 6 130 50 0 34 -2 36 -25 30 -179 -45 -295
34 -295 201 0 108 52 176 154 204 39 11 95 4 149 -16 14 -6 17 -1 17 29 0 30
-5 38 -25 46 -39 15 -116 20 -162 10z"
      />
      <path d="M2051 697 c-6 -6 -11 -16 -11 -21 0 -6 5 -3 11 6 5 10 16 15 24 12 8
-4 15 -4 15 -1 0 11 -28 15 -39 4z"
      />
      <path d="M2101 703 c4 -20 -2 -32 -18 -35 -16 -3 -16 -4 -2 -10 19 -7 45 37
28 47 -5 4 -9 3 -8 -2z"
      />
      <path d="M550 697 c0 -5 25 -86 55 -181 30 -94 55 -175 55 -179 0 -4 -56 -7
-124 -7 l-124 0 49 152 c27 84 47 153 45 155 -4 4 -116 -301 -116 -317 0 -23
40 -68 74 -84 75 -36 171 -11 208 55 l20 34 -71 190 c-38 105 -70 186 -71 182z"
      />
      <path d="M205 650 c4 -14 27 -86 51 -161 24 -75 44 -142 44 -148 0 -7 -38 -11
-120 -11 -78 0 -120 4 -120 11 0 5 21 73 46 150 25 78 44 142 42 144 -2 2 -30
-67 -62 -155 l-58 -159 21 -34 c55 -89 208 -90 265 -2 9 13 16 30 16 36 0 14
-119 342 -127 349 -3 3 -2 -6 2 -20z"
      />
      <path d="M2040 654 c0 -27 60 -48 74 -25 3 4 -6 6 -21 3 -18 -3 -30 1 -40 13
-7 11 -13 14 -13 9z"
      />
      <path d="M349 425 c0 -55 -4 -122 -7 -150 -7 -47 -10 -51 -52 -73 l-44 -22
114 0 114 0 -44 23 c-42 21 -45 25 -52 72 -3 28 -7 88 -7 135 -2 126 -20 139
-22 15z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CsgCgc',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
